import React,{useState,useRef,useEffect} from 'react'
import axios from 'axios'
import Cleave from 'cleave.js/react'
import { Formik, Field, FieldArray } from 'formik'
import { Form, Input, TextArea, Button, Select, Step, Label, Dropdown, Dimmer, Loader, Icon, Message, Modal, Checkbox, Popup, Table, Segment } from 'semantic-ui-react'

import Spinner from '../../services/spinner'
import AlertMessage from '../../services/alert'
import { WindowReload, WindowURL, WindowLocation, RouteURL, RedirectURL } from '../../services/redirect'
import { ValidateInvite } from '../../validations/schemaCustomer'
import { DropdownComponent } from '../../components/options'
import AuthDenied from '../ErrorPage/denied'


export default function InviteComponent(props){


  /*----------------------------------------
    GENERATE PASSWORD
  -----------------------------------------*/

  function MakePassword(length) {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNPQRSTUVWXYZabcdefghijklmnpqrstuvwxyz123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
     }
     return result;
  }


  /*----------------------------------------
    SPINNER
  -----------------------------------------*/
  const [spinner,setspinner] = useState(true);
  const [contentspinner, setcontentspinner] = useState({});
  function SpinnerCallback(data){
    if(data.intent=='close'){
      setspinner(false);
    }
  }


  /*------------------------------------------------------
    ALERT MESSAGE NOTIFY
  -------------------------------------------------------*/
  const [notify,setnotify] = useState(true);
  const [nofitycontent, setnofitycontent] = useState({});
  function Notifycallback(data){
    if(data.intent=='close'){
      setnotify(false);
    }
  }



  /*----------------------------------------
    Handle Form Submit
  -----------------------------------------*/
  const buttonEl = useRef(null);
  const [buttonclick, setbuttonClick] = useState(0);
  function buttonSubmit(arg){
      setbuttonClick(arg);
      buttonEl.current.click();
  }
  const [state, setState] = useState({
    account_number:'',
    account_name:'',
    short_name:'',
    email:'',
    subject:'',
    message:''
  });

  function handleSubmitForm(values, props){

    setcontentspinner({intent:'spinner',settings:{options:'overlay',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Processing',text:""}});
    setspinner(true);

    let formData = new FormData();
    formData.append('type','invite');
    formData.append('info',JSON.stringify(values));
    axios.post('/admin/customers/request.php',formData)
    .then(function (response) {
      let obj = response.data;

      setspinner(false);

      if(obj=='success'){
        setnofitycontent({intent:'success',settings:{onclose:true,reload:false,title:'Congratulations!',text:'Data successfully saved.'}});
        setnotify(true);
        setTimeout(function() {setnotify(false);},2000);
        if(buttonclick==1){
          setTimeout(function() {
            WindowLocation('/customers/list');
          },2000);
        }else{
          props.resetForm();
          setTimeout(function() {
            setnotify(false);
          },2000);
        }
        return false;
      }


      if(obj=='error'){
        setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Something Wrong!',text:'Failed to connect through the server.'}});
        setnotify(true);
        setTimeout(function() {
          setnotify(false);
        },3000);
        return false;
      }

      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Input Error!',text:'Please correct the required fields.'}});
      setnotify(true);
      setTimeout(function() {
        setnotify(false);
      },3000);

      Object.keys(obj).forEach(function(key) {
        props.setErrors(obj);
      });

    })
    .catch(function (error){
      setspinner(false);
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
      setTimeout(function() {
        setnotify(false);
      },3000);
    });


  }





  /*---------------------------------------------------------------------------------------------------------------------------------------
         AUTH PERMISSION FOR PAGES
  ----------------------------------------------------------------------------------------------------------------------------------------*/
  const [loader,setloader] = useState(true);
  const [pageId, setPageId] = useState('pe4wsybrqkz1ch2tg');
  const [authPages, setAuthPages] = useState({
    view:0,
    adding:0,
    editing:0,
    deleting:0
  });
  function AuthPagesPermission(){

    setcontentspinner({intent:'spinner',settings:{options:'relative',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Loading',text:""}});
    setloader(true);

    let formData = new FormData();
    formData.append('type','authPages');
    formData.append('id',pageId);
    axios.post('/admin/users-management/users-permission/request.php',formData)
    .then(function (response) {
        let obj = response.data;
        setAuthPages({
          view:obj.view,
          adding:obj.adding,
          editing:obj.editing,
          deleting:obj.deleting,
        });

        if(obj.view==1){

        }
        setloader(false);
        setspinner(false);

    })
    .catch(function (error){
      setloader(false);
      setspinner(true);
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
      setTimeout(function() {setnotify(false);},3000);
    });
 }

  useEffect(()=>{
    AuthPagesPermission();
  },[]);

  return (
    <React.Fragment>

      {spinner&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}
      {notify&&<AlertMessage data={nofitycontent} callback={Notifycallback}/>}

      {((authPages['view']==0||authPages['adding']==0)&&!loader)&&<AuthDenied/>}
      {(authPages['view']==1&&!loader)&&<React.Fragment>

      <div className="page-wrapper-half">
        <div className="app-page-title">
         <div className="page-title-wrapper">
            <div><h1>Invite Customer</h1></div>
            <div>
            <Button className='LightGrayButton strong' size='tiny' content='Refresh' icon='sync alternate icon' onClick={()=>WindowReload()}/>
            <Button className='GreenButton strong' size='tiny' content='Back to list' icon='arrow left icon' as="a" href={WindowURL('/customers/list')}/>
            </div>
          </div>
       </div>
      <div className="app-body-wrapper">
      <Form>
        <Formik
            initialValues={state}
            validationSchema={ValidateInvite}
            onSubmit={handleSubmitForm}
            render={formProps => {
            const { values, isSubmitting, errors, handleChange, handleBlur, handleSubmit, isValid, dirty, touched, setFieldValue } = formProps
            return(
                    <div className="page-form-panel">
                        <div className="page-form-body">

                        <div class="alert-message left error">
                            <div><i class="info circle icon"></i></div>
                            <div><p>Fields with asterisk is required.</p></div>
                        </div>
                        <br/>
                        
                        <Form.Group widths="equal">
                            <Field name="email">
                                {({ field, form }) => (
                                <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                  <label>Email</label>
                                  <Input {...field} onChange={handleChange}/>
                                  { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                </Form.Field>
                                )}
                          </Field>
                       </Form.Group>
                        <Form.Group widths="equal">
                            <Field name="account_number">
                                {({ field, form }) => (
                                <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                  <label>Account Number</label>
                                  <Cleave {...field} onChange={handleChange} placeholder="Enter number only" options={{numericOnly: true}} maxLength="15"/>
                                  { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                </Form.Field>
                                )}
                          </Field>
                         </Form.Group>
                         <Form.Group widths="equal">
                               <Field name="account_name">
                                   {({ field, form }) => (
                                   <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                     <label>Account Name</label>
                                     <Input {...field} onChange={handleChange}/>
                                     { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                   </Form.Field>
                                   )}
                             </Field>
                          </Form.Group>
                          <Form.Group widths="equal">
                                <Field name="short_name">
                                    {({ field, form }) => (
                                    <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                      <label>Profile Name</label>
                                      <Input {...field} onChange={handleChange} maxLength="20" placeholder="Max of 20 characters"/>
                                      { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                    </Form.Field>
                                    )}
                              </Field>
                           </Form.Group>

                           <div class="alert-message left info" style={{'margin-bottom':'15px'}}>
                               <div><i class="info circle icon"></i></div>
                               <div>
                                  <p>Profile name will be use in customer portal.</p>
                                  <p>Example: Instead of <span style={{'font-weight':'700'}}>John Pharmacy Ltd T/A Charles John Pharmacy</span>, make it short like <span style={{'font-weight':'700'}}>John Pharmacy</span>.</p>
                               </div>
                           </div>

                          <Form.Group widths="equal">
                                <Field name="subject">
                                    {({ field, form }) => (
                                    <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                      <label>Subject Email</label>
                                      <Input {...field} onChange={handleChange}/>
                                      { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                    </Form.Field>
                                    )}
                              </Field>
                           </Form.Group>

                           <Form.Group widths="equal">
                                 <Field name="message">
                                     {({ field, form }) => (
                                     <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                       <label>Message</label>
                                       <TextArea {...field} onChange={handleChange}/>
                                       { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                     </Form.Field>
                                     )}
                               </Field>
                           </Form.Group>

                        </div>{/*.page-form-body*/}

                        <div className="page-form-footer">
                        <Button disabled={spinner||authPages['adding']==0} className='LightGrayButton strong' size='small' content='Save and back to list' icon='save icon' onClick={() => buttonSubmit(1)}/>
                        <Button disabled={spinner||authPages['adding']==0} className='PrimaryButton strong' size='small' content='Save and stay on page' icon='save icon' onClick={() => buttonSubmit(2)}/>
                            <button type="button" className="display_none" ref={buttonEl} onClick={handleSubmit}></button>
                        </div>

                 </div>

            )}}/>
          </Form>
          </div>
        </div>
      </React.Fragment>}
    </React.Fragment>
  )
}
